module.exports = __webpack_public_path__ + "static/media/case_12.653dcc26.jpg";